module.exports = __webpack_public_path__ + "10_mole.cd584c2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer2/10_mole.png
// module id = YVJI
// module chunks = 0